import React from "react";
import { Row, Col } from "reactstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import PatientProfileHeaderPrint from "../Reusable/PatintProfileHeaderPrint";
import LottieLoader from '../../components/LottieLoader';
import lottieEmptyFile from '../../files/animation/empty_new.json';
const QuestionnaireListPrint = ({ myQuestionnaire, profile, latestReadingUser, ccmTotalDuration, rpmTotalDuration }) => {
    return (
        <div>
            <PatientProfileHeaderPrint
                profile={profile}
                latestReadingUser={latestReadingUser}
                ccmTotalDuration={ccmTotalDuration}
                rpmTotalDuration={rpmTotalDuration}>
            </PatientProfileHeaderPrint>
            <div>
                <Row>
                    <Col sm="12" className="mt-12">
                        {myQuestionnaire && (
                            <ToolkitProvider
                                bootstrap4
                                keyField="_id"
                                data={myQuestionnaire && myQuestionnaire.length > 0 ? myQuestionnaire : []}
                                search={{
                                    searchFormatted: true
                                }}
                                columns={[
                                    {
                                        dataField: "createdAt",
                                        text: "Date",
                                        formatter: (cell, row) => {
                                            return new Date(row.createdAt).toString();
                                        },
                                        csvFormatter: (cell, row) => {
                                            return new Date(row.createdAt).toString();
                                        }
                                    },
                                    {
                                        dataField: "questionnaireName",
                                        text: "Questionnaire",
                                        formatter: (cell, row) => {
                                            return row.questionnaireName;
                                        },
                                        csvFormatter: (cell, row) => {
                                            return row.questionnaireName;
                                        }
                                    },
                                    {
                                        dataField: "createdByName",
                                        text: "Created By",
                                        formatter: (cell, row) => {
                                            return row.createdByName;
                                        },
                                        csvFormatter: (cell, row) => {
                                            return row.createdByName;
                                        }
                                    },
                                    {
                                        dataField: "questionnaireRepeatPer",
                                        text: "Frequency",
                                        formatter: (cell, row) => {
                                            return row.questionnaireRepeatPer;
                                        },
                                        csvFormatter: (cell, row) => {
                                            return row.questionnaireRepeatPer;
                                        }
                                    },
                                ]}
                            >
                                {(toolKitProp) => (
                                    <div>
                                        {<BootstrapTable
                                            className="table"
                                            wrapperClasses="table-responsive"
                                            keyField="_id"
                                            noDataIndication={() => (
                                            <div>
                                                <LottieLoader
                                                    loadLoop={false}
                                                    autoplayLoop={true}
                                                    source={lottieEmptyFile}
                                                    Lheight={200}
                                                    Lwidth={200}
                                                    titleSmall={"Sorry! No Questionnaire found"}
                                                    subTitleSmall={"We can't find any Questionnaire data for this patient."}
                                                />
                                            </div>
                                            )}
                                            {...toolKitProp.baseProps}
                                        />}
                                    </div>
                                )}
                            </ToolkitProvider>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default QuestionnaireListPrint;